import { PipeModule } from '../../../pipe/pipe.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ListButtonsComponent } from './list-buttons.component';


@NgModule({
  declarations: [ListButtonsComponent],
  exports: [ListButtonsComponent],
  imports: [
    IonicModule,
    CommonModule,
    PipeModule
  ]
})
export class ListButtonsModule { }
